export default "__VITE_ASSET__BjDiPJRD__"